import {
    createEffect,
    on,
} from 'solid-js'

/**
 * TENANT-5814: keep the search page's template chrome in step with the session.
 *
 * The search wrapper shows the dashboard sidebar and hides the login header while signed in. It
 * used to re-apply that chrome only when authentication turned true: a logout that starts outside
 * the page (the browser extension's Log Out, a logout in another tab, a session the API rejected)
 * flipped the signal to false and nothing listened, so `/search` kept the signed-in sidebar with
 * its own Log Out until a reload rebuilt the template from storage.
 *
 * The signal boots `false` and is only confirmed later, so the initial `false` is still ignored:
 * reacting to it would flash the signed-in chrome away on a hard refresh (the wrapper's mount read
 * of the stored token covers that case). Only a true → false change applies the signed-out chrome.
 *
 * @param {object} api
 * @param {() => boolean} api.isAuthenticated - `SessionService.isAuthenticated`.
 * @param {(authenticated: boolean) => void} api.applyTemplateSettings
 */
export const syncSearchTemplateWithSession = ({
    applyTemplateSettings,
    isAuthenticated,
}) => {
    createEffect(on(isAuthenticated, (authenticated, previouslyAuthenticated) => {
        if (authenticated) {
            applyTemplateSettings(true)
            return
        }
        if (previouslyAuthenticated) {
            applyTemplateSettings(false)
        }
    }))
}
